import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';
import './AdminLayout.css';

const NAV_ITEMS = [
  { path: '/admin',          label: '📊 Dashboard',    exact: true },
  { path: '/admin/orgs',     label: '🏢 Organisations' },
  { path: '/admin/users',    label: '👥 Users' },
  { path: '/admin/projects', label: '📁 Projects' },
  { path: '/admin/reviews',  label: '🔍 Stage Reviews' },
  { path: '/admin/stats',    label: '📈 Stats' },
];

const AdminLayout = ({ children, title }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActive = (item) =>
    item.exact
      ? location.pathname === item.path
      : location.pathname.startsWith(item.path) && location.pathname !== '/admin';

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <img src="/final_logo.png" alt="Batos CodeHub" style={{ width: 140, objectFit: 'contain' }} />
          <span className="admin-badge">Admin</span>
        </div>

        <nav className="admin-nav">
          {NAV_ITEMS.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-item ${isActive(item) ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user">
            <div className="admin-avatar">{user?.full_name?.charAt(0)}</div>
            <div>
              <div className="admin-user-name">{user?.full_name}</div>
              <div className="admin-user-email">{user?.email}</div>
            </div>
          </div>
          <button className="admin-logout" onClick={handleLogout}>Logout</button>
        </div>
      </aside>

      {/* Main content */}
      <main className="admin-main">
        {title && (
          <div className="admin-page-header">
            <h1>{title}</h1>
          </div>
        )}
        <div className="admin-page-body">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
